import axios from 'axios'
import constants from '@helpers/Constants'
import { getLocale } from '@helpers/language/TranslationHelper'
import { useAuthStore } from 'src/stores/auth'
import { useAppStore } from 'src/stores/app'
import { UnitsService } from '@services/UnitsService'

const apiURL = constants.apiURL

const options = {
  baseURL: apiURL,
  withCredentials: true
}

const axiosRequest = axios.create(options)
const axiosRequestNoInterceptors = axios.create(options)

// Interceptor para añadir el token a las peticiones
axiosRequest.interceptors.request.use(
  (config) => {
    // const token = TokenService.getLoginToken()
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }

    config.headers.language = getLocale()
    config.headers.units = UnitsService.getUnits()
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// Interceptor en caso de error token https://thedutchlab.com/blog/using-axios-interceptors-for-refreshing-your-api-token
axiosRequest.interceptors.response.use(
  (response) => {
    return response
  },
  async function (error) {
    const originalRequest = error.config
    if (
      error.response &&
      error.response.status === 401 &&
      originalRequest.path !== '/login'
    ) {
      useAuthStore().logout(true)
      useAppStore().SET_LOADING(false)
    }
    return Promise.reject(error)
  }
)

export const request = axiosRequest
export const requestNoInterceptors = axiosRequestNoInterceptors
